import React from "react";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import { connect } from "react-redux";
import { login } from "../../modules/actions/authActions";
import PropTypes from "prop-types";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";
import { Link, withRouter } from "react-router-dom";
import { isEmailDomain } from "../../modules/utils";
import NotificationAlert from "react-notification-alert";


function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.identifier)) {
    errors.identifier = "This field is required";
  }
  if (!isEmailDomain(data.identifier)) {
    errors.identifier = "Please enter valid Email id";
  }
  if (Validator.isEmpty(data.password)) {
    errors.password = "This field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      identifier: "",
      password: "",
      errors: {},
      isLoading: false
    };
  }

  componentDidMount() {
    console.log("loginFormProps",this.props);
    const self = this;
    let identifier = document.getElementById("identifier");
    let password = document.getElementById("password");
    identifier.addEventListener("keyup", function(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        self._handleLogin();
      }
    });

    password.addEventListener("keyup", function(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        self._handleLogin();
      }
    });
  }
  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }


  _handleLogin = () => {
    let reqpayload = this.state;

    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.login(reqpayload).then(
        res => {
          // if (typeof this.props.location !== "undefined" && typeof this.props.location.state.cart !== "undefined"){
          //   this.performCartAction(this.props.location.state.cart)
          // }else
          if (this.props.auth.redirect) {
            console.log("propsLocation", this.props.location);
            console.log("propsRedirectPath", this.props.auth.redirect);
            console.log("redirectPayload",this.props.auth.redirectPayload);

            this.context.router.history.push({
              pathname : this.props.auth.redirect,
              params : (typeof this.props.location !== "undefined") ? this.props.location.params : null
            });

          } else {
            this.context.router.history.push("/dashboard");
          }
        },
        err => {
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{err.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
        }
      );
    }
  };

  render() {
    const { errors, identifier, password } = this.state;
    const { auth } = this.props;
    if (auth.isAuthenticated) {
      this.context.router.history.push("/dashboard");
    }
    return (
      <section className="section FullSection">
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-6 no-padding">
            <div className="LoginBanner"></div>
            </div>

            <div className="col-md-6">
              <div className="text-left LoginFormSet">

                <div className="row justify-content-md-center align-items-center">

                  <NotificationAlert ref="notify" />

                    <div className="col-md-6">

                      <h2 className="font-weight-bold">SIGN IN</h2>

                      <div className="form-group">
                        <TextFieldGroup
                          field="identifier"
                          id="identifier"
                          value={identifier}
                          error={errors.identifier}
                          placeholder="Email Address"
                          onChange={this._onChange}
                        />
                      </div>

                      <div><input id="staylogin" type="checkbox" /> <label for="staylogin">Stay Logged In</label></div>

                      <div className="form-group">
                        <TextFieldGroup
                          field="password"
                          id="password"
                          value={password}
                          onChange={this._onChange}
                          error={errors.password}
                          type="password"
                          placeholder="Password"
                        />
                      </div>

                      <div><Link to="/forgot-password"><u>Forgot Password?</u></Link></div>

                      <div className="mt-4">
                      <a href="javascript:void(0)" className="btn btn-orange" onClick={this._handleLogin}>SIGN IN</a>
                      </div>

                      <div style={{ clear: "both", height: "20px" }} />

                      <div>Don't have an account yet? <Link to="/signup">SIGN UP</Link></div>

                    </div>
                </div>

                <div style={{ clear: "both", height: "100px" }} />
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired
};

LoginForm.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default withRouter(connect(
  mapStateToProps,
  { login }
)(LoginForm));



// WEBPACK FOOTER //
// ./src/pages/login/LoginForm.js